import { useSearchFiltersStore } from '@aibees/elephant/feature/search-filters/store';
import { usePeopleDrawerStore } from '@aibees/elephant/feature/search-table-people/components/people-drawer/store';
import { useSearchPersonStore } from '@aibees/elephant/feature/search-table-people/store';
import { useSearchTypeFromRoute, useTrackEvents } from '@aibees/elephant/hooks';
import { SearchType } from '@aibees/elephant/types';
import { useTableSearchItemStore } from '@aibees/shared/store/table-search-item';
import { classnames } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import { forwardRef, useCallback } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { QuickViewProps as Props } from './types';

export const QuickView = forwardRef<HTMLDivElement, Props>(
  ({ className, id, hasUpdate }, ref) => {
    const searchType = useSearchTypeFromRoute();
    const { setSelectedItem } = useTableSearchItemStore();
    const setId = useSearchPersonStore.useSetId();
    const setCurrentItemId = useSearchFiltersStore.useSetSelectedItemId();
    const { track } = useTrackEvents();
    const { setDefaultActiveTab } = usePeopleDrawerStore();

    const handleClick = useCallback(() => {
      track(`OPEN_SIDEBAR`, { searchType });
      setSelectedItem(id);
      if (searchType === SearchType.People) {
        setId(id);
        if (hasUpdate) setDefaultActiveTab('Update');
        else setDefaultActiveTab('Overview');
      } else setCurrentItemId(id);
    }, [id, hasUpdate]);

    return (
      <Styled.Wrapper
        className={classnames('QuickView', className)}
        sx={SX.root}
        ref={ref}
      >
        <Button
          variant={hasUpdate ? 'outlined' : 'contained'}
          color="primary"
          size="xsmall"
          onClick={handleClick}
          sx={{ ml: 1 }}
        >
          {hasUpdate ? 'View Update' : 'Quick View'}
        </Button>
      </Styled.Wrapper>
    );
  }
);
QuickView.displayName = 'QuickView';
